import React from "react";
import { node, string } from "prop-types";
import Tooltip from "./Tooltip";

const KPIBox = ({ children, extras = [], title, tooltip }) => (
  <div className="c-layout-card flex-grow-1 mb-24">
    <header className="c-layout-card__header">
      <h5 className="c-layout-card__title">
        {title}
        {tooltip && <Tooltip text={tooltip} />}
      </h5>
    </header>
    <div className="c-layout-card__content">{children}</div>
    {extras.length > 0 ? (
      <footer className="c-layout-card__footer">
        <div className="c-layout-card__footer-column-left">
          <div className="flex gap-8 flex-column">
            {extras
              .filter((item) => Boolean(item))
              .map((item, index) => (
                <div key={index}>{item}</div>
              ))}
          </div>
        </div>
      </footer>
    ) : null}
  </div>
);

export default KPIBox;

KPIBox.propTypes = {
  children: node,
  title: string,
  tooltip: string,
};
